import React from 'react'

import EbestDividendInvestingGuide from '@/components/pages/ebest/ebest-dividend-investing-guide'
import EbestWebViewLayout from '@/components/pages/ebest/ebest-components/ebest-webview-layout'
const DividendInvestingGuidePage = () => {
  return (
    <>
      {/*<DividendInvestingGuidePageSEO />*/}
      <EbestWebViewLayout>
        <EbestDividendInvestingGuide />
      </EbestWebViewLayout>
    </>
  )
}

export default DividendInvestingGuidePage
